const systemStatus = {
  danger: "red",
};

export default systemStatus;
